// extracted by mini-css-extract-plugin
export default {"slideshow":"images-slideshow_slideshow__52U8+","active":"images-slideshow_active__wo0CM"};